import * as React from 'react'

/* UTILITIES START */

export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>

export namespace SizeNS {
  export const auto = 'auto'
  export const block = 'block'
  export const inherit = ''
  export const lg = 'lg'
  export const md = 'md'
  export const none = 'none'
  export const sm = 'sm'
  export const xl = 'xl'
  export const xs = 'xs'
  export const xxl = 'xxl'
}

export namespace PlacementNS {
  export const bottom = 'bottom'
  export const bottomLeft = 'bottom-left'
  export const bottomRight = 'bottom-right'
  export const center = 'center'
  export const left = 'left'
  export const leftBottom = 'left-bottom'
  export const leftTop = 'left-top'
  export const right = 'right'
  export const rightBottom = 'right-bottom'
  export const rightTop = 'right-top'
  export const top = 'top'
  export const topLeft = 'top-left'
  export const topRight = 'top-right'
}

export type Placement =
  | typeof PlacementNS.bottom
  | typeof PlacementNS.bottomLeft
  | typeof PlacementNS.bottomRight
  | typeof PlacementNS.center
  | typeof PlacementNS.left
  | typeof PlacementNS.leftBottom
  | typeof PlacementNS.leftTop
  | typeof PlacementNS.right
  | typeof PlacementNS.rightBottom
  | typeof PlacementNS.rightTop
  | typeof PlacementNS.top
  | typeof PlacementNS.topLeft
  | typeof PlacementNS.topRight

export interface Props {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export interface AccessibleProps {
  tabIndex?: number
}

export type AnchorAttributes = React.AnchorHTMLAttributes<HTMLAnchorElement>

export type ButtonAttributes = React.ButtonHTMLAttributes<HTMLButtonElement>

export type DivAttributes = React.HTMLAttributes<HTMLDivElement>

export type HeadingAttributes = React.HTMLAttributes<HTMLHeadingElement>

export type InputAttributes = React.InputHTMLAttributes<HTMLInputElement>

export type LabelAttributes = React.HTMLAttributes<HTMLLabelElement>

export type LiAttributes = React.LiHTMLAttributes<HTMLLIElement>

export type OlAttributes = React.OlHTMLAttributes<HTMLOListElement>

export type NavAttributes = DivAttributes

export type SpanAttributes = React.HTMLAttributes<HTMLSpanElement>

export type TableAttributes = React.TableHTMLAttributes<HTMLTableElement>

export type TbodyAttributes = DivAttributes

export type TdAttributes = React.TdHTMLAttributes<HTMLTableCellElement>

export type TheadAttributes = DivAttributes

export type TextAreaAttributes = React.TextareaHTMLAttributes<
  HTMLTextAreaElement
>

export type ThAttributes = React.ThHTMLAttributes<HTMLTableHeaderCellElement>

export type TrAttributes = DivAttributes

export type UlAttributes = DivAttributes
